var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadModalDropzoneGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sound_104886 1",
    clipPath: "url(#clip0_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 41,
    height: 49
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2842",
    d: "M10.5227 7.48839C8.04943 7.48839 6.02612 9.51203 6.02612 11.9851V51.2941C6.02612 53.7674 8.04943 55.791 10.5227 55.791H42.2741C44.7474 55.791 46.7708 53.7674 46.7708 51.2941V18.6157C46.7708 17.6408 46.3584 16.7113 45.6354 16.0575L37.1466 8.37974C36.5126 7.806 35.6876 7.48839 34.8326 7.48839H10.5227Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2838"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g2844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2846",
    d: "M34.8325 7.48857H10.5225C8.04958 7.48857 6.02612 9.51203 6.02612 11.9853V51.2943C6.02612 53.7676 8.04958 55.791 10.5225 55.791H42.2741C44.7474 55.791 46.7708 53.7676 46.7708 51.2943V18.6159C46.7708 17.641 46.3583 16.7115 45.6352 16.0575L37.1466 8.37975C36.5124 7.80618 35.6876 7.48857 34.8325 7.48857Z",
    fill: "#E7E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 15,
    width: 11,
    height: 10
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2854",
    d: "M36.9351 15.467H46.7704V24.041H36.9351V15.467Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2858",
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2862",
    d: "M36.9353 17.2924L46.7708 24.0371V15.4644L36.9353 17.2924Z",
    fill: "black"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g2864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2866",
    d: "M35.4346 6.82938L48.3317 18.4941H40.035C37.4942 18.4941 35.4346 16.4346 35.4346 13.8939V13.6476V6.82938Z",
    fill: "#D2D3D4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 8,
    height: 7
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2874",
    d: "M7.53735 8.98823H14.4179V14.2461H7.53735V8.98823Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2878",
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2882",
    d: "M8.33825 14.2253C7.79085 14.1078 7.44201 13.5692 7.5597 13.0212C8.14965 10.2719 10.8664 8.5149 13.6161 9.10485C14.1635 9.22236 14.5121 9.76099 14.3946 10.3089C14.2771 10.8568 13.738 11.2048 13.1906 11.0874C11.5343 10.732 9.89755 11.7904 9.54213 13.4467C9.42478 13.9946 8.88565 14.3426 8.33825 14.2253Z",
    fill: "white"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "g2884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -5,
    width: 38,
    height: 38
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2890",
    d: "M-5.98755 -4.70485H31.6196V32.9023H-5.98755V-4.70485Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2894",
    opacity: 0.649994
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2898",
    d: "M31.6193 14.0992C31.6193 24.484 23.2009 32.9023 12.8162 32.9023C2.43146 32.9023 -5.98706 24.484 -5.98706 14.0992C-5.98706 3.71451 2.43146 -4.70401 12.8162 -4.70401C23.2009 -4.70401 31.6193 3.71451 31.6193 14.0992Z",
    fill: "white"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g2900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -505,
    y: -390,
    width: 607,
    height: 782
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2906",
    d: "M-504.847 -389.85H101.321V391.75H-504.847V-389.85Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 24,
    width: 31,
    height: 21
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2914",
    d: "M11.4849 24.045H41.0111V44.3438H11.4849V24.045Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2918",
    opacity: 0.270004
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2922",
    d: "M39.4445 27.3418H13.0514C12.1895 27.3418 11.4844 26.6367 11.4844 25.7749V25.6131C11.4844 24.7512 12.1895 24.0461 13.0514 24.0461H39.4445C40.3063 24.0461 41.0112 24.7512 41.0112 25.6131V25.7749C41.0112 26.6367 40.3063 27.3418 39.4445 27.3418Z",
    fill: "#323139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2926",
    d: "M39.4445 35.8418H13.0514C12.1895 35.8418 11.4844 35.1367 11.4844 34.2751V34.1131C11.4844 33.2514 12.1895 32.5462 13.0514 32.5462H39.4445C40.3063 32.5462 41.0112 33.2514 41.0112 34.1131V34.2751C41.0112 35.1367 40.3063 35.8418 39.4445 35.8418Z",
    fill: "#323139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2930",
    d: "M39.4445 44.3457H13.0514C12.1895 44.3457 11.4844 43.6406 11.4844 42.779V42.6171C11.4844 41.7553 12.1895 41.0502 13.0514 41.0502H39.4445C40.3063 41.0502 41.0112 41.7553 41.0112 42.6171V42.779C41.0112 43.6406 40.3063 44.3457 39.4445 44.3457Z",
    fill: "#323139"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g2932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 41,
    height: 50
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2938",
    d: "M19.506 3.74072C17.0329 3.74072 15.0093 5.76414 15.0093 8.23741V47.5464C15.0093 50.0195 17.0329 52.043 19.506 52.043H51.2576C53.7307 52.043 55.7541 50.0195 55.7541 47.5464V14.868C55.7541 13.8929 55.3416 12.9636 54.6186 12.3095L46.1297 4.63186C45.4959 4.05829 44.671 3.74072 43.8157 3.74072H19.506Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2934"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g2940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2942",
    d: "M43.8159 3.74248H19.5061C17.033 3.74248 15.0095 5.76593 15.0095 8.2392V47.5482C15.0095 50.0215 17.033 52.0449 19.5061 52.0449H51.2575C53.7308 52.0449 55.7542 50.0215 55.7542 47.5482V14.8698C55.7542 13.8949 55.3417 12.9654 54.6186 12.3114L46.13 4.63366C45.4958 4.06008 44.671 3.74248 43.8159 3.74248Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 11,
    width: 11,
    height: 10
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2950",
    d: "M45.9194 11.7206H55.7547V20.293H45.9194V11.7206Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2954",
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2958",
    d: "M45.9189 13.5481L55.7543 20.293V11.7201L45.9189 13.5481Z",
    fill: "black"
  })))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g2960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2962",
    d: "M44.418 3.08328L57.3151 14.748H49.0184C46.4776 14.748 44.418 12.6885 44.418 10.1478V9.90147V3.08328Z",
    fill: "#E7E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 8,
    height: 6
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2970",
    d: "M16.52 5.24187H23.4005V10.498H16.52V5.24187Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2974",
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2978",
    d: "M17.3214 10.4714C16.774 10.3539 16.4252 9.81525 16.5429 9.26734C17.1328 6.51801 19.8495 4.76099 22.5994 5.35094C23.1466 5.46846 23.4953 6.00708 23.3778 6.55499C23.2602 7.10289 22.7211 7.45089 22.1737 7.33354C20.5175 6.97812 18.8807 8.03645 18.5255 9.69283C18.4079 10.2407 17.8688 10.5887 17.3214 10.4714Z",
    fill: "white"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "g2980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: -9,
    width: 39,
    height: 39
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2986",
    d: "M2.99634 -8.44508H40.6018V29.1621H2.99634V-8.44508Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2990",
    opacity: 0.639999
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2994",
    d: "M40.6025 10.359C40.6025 20.7438 32.1841 29.1621 21.7994 29.1621C11.4146 29.1621 2.99609 20.7438 2.99609 10.359C2.99609 -0.0257263 11.4146 -8.44425 21.7994 -8.44425C32.1841 -8.44425 40.6025 -0.0257263 40.6025 10.359Z",
    fill: "white"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g3004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_144_4229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 30,
    height: 21
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    d: "M20.4673 20.2855H49.9952V40.5859H20.4673V20.2855Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_144_4229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3014",
    opacity: 0.520004
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    d: "M48.4282 23.5801H22.0352C21.1734 23.5801 20.4683 22.875 20.4683 22.0132V21.8514C20.4683 20.9895 21.1734 20.2845 22.0352 20.2845H48.4282C49.29 20.2845 49.995 20.9895 49.995 21.8514V22.0132C49.995 22.875 49.29 23.5801 48.4282 23.5801Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    d: "M48.4282 32.084H22.0352C21.1734 32.084 20.4683 31.379 20.4683 30.5173V30.3555C20.4683 29.4935 21.1734 28.7884 22.0352 28.7884H48.4282C49.29 28.7884 49.995 29.4935 49.995 30.3555V30.5173C49.995 31.379 49.29 32.084 48.4282 32.084Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    d: "M48.428 40.584H22.0349C21.1731 40.584 20.468 39.8789 20.468 39.0173V38.8553C20.468 37.9935 21.1731 37.2884 22.0349 37.2884H48.428C49.2898 37.2884 49.9947 37.9935 49.9947 38.8553V39.0173C49.9947 39.8789 49.2898 40.584 48.428 40.584Z",
    fill: "black"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_4229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadModalDropzoneGraphic);
export default __webpack_public_path__ + "static/media/upload-modal-dropzone-graphic.cbb436d0948ff1746a33e8a0ba85ac5d.svg";
export { ForwardRef as ReactComponent };